import { call } from './call';

export const createDirectToken = (bsb, number, accountName, lastName) => {
  const params = {
    AccountBSB: bsb,
    AccountNumber: number,
    AccountName: accountName,
    LastName: lastName,
  };

  return call(params);
};



// WEBPACK FOOTER //
// ./lib/ezidebit/createDirectToken.ts